import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    inject,
    Inject,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import {
    FormControl,
    FormGroup,
    FormsModule,
    NonNullableFormBuilder,
    ReactiveFormsModule,
} from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import {
    NzFormControlComponent,
    NzFormDirective,
    NzFormItemComponent,
    NzFormModule,
} from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import {
    NZ_MODAL_DATA,
    NzModalFooterDirective,
    NzModalRef,
    NzModalTitleDirective,
} from 'ng-zorro-antd/modal';
import { NzOptionComponent, NzSelectComponent } from 'ng-zorro-antd/select';
import { NzTableModule } from 'ng-zorro-antd/table';
import { Subject, takeUntil } from 'rxjs';
import { ArticleFamilyService } from 'src/app/private/services/article-family.service';
import { ArticlesService } from 'src/app/private/services/articles.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { ArticleFamilyDto } from 'src/app/shared/dto/article-family.dto';
import { ArticleSearchResponseDto } from 'src/app/shared/dto/pagination/articles-search-response.dto';

@Component({
    selector: 'app-modal-search-articles',
    templateUrl: './modal-search-articles.component.html',
    styleUrl: './modal-search-articles.component.scss',
    standalone: true,
    imports: [
		NzTableModule,
        NzModalTitleDirective,
        NzModalFooterDirective,
        ReactiveFormsModule,
        NzFormDirective,
        NzRowDirective,
        NzFormItemComponent,
        NzColDirective,
        NzFormControlComponent,
        NzInputDirective,
        NzSelectComponent,
        NzOptionComponent,
        NzMessageModule,
        NzFormModule,
        ReactiveFormsModule,
        FormsModule,
        LoaderComponent,
        NzButtonModule,
        NzDividerComponent,
		NzEmptyModule
    ],
})
export class ModalSearchArticlesComponent implements OnInit, OnDestroy {
    @Output() emitService = new EventEmitter();

    isLoading: boolean = true;
    isSearching: boolean = false;
	isSaving: boolean = false;

	tableHeight!: number;

	articleFamilies: ArticleFamilyDto[] = [];
    articleFamiliesSelected: ArticleFamilyDto[] = [];

	articles: ArticleSearchResponseDto[] = [];
    articlesToRemove: ArticleSearchResponseDto[] = [];

    validateForm: FormGroup<{
        article: FormControl<string>;
        familiesIds: FormControl<number[]>;
        articleBatch: FormControl<string>;
		packagingBatch: FormControl<string>;
    }>;

    private unsubscribe$ = new Subject<void>();

    private readonly modalRef = inject(NzModalRef);
	private readonly articleFamilyService = inject(ArticleFamilyService);
	private readonly articlesService = inject(ArticlesService);
	private readonly message = inject(NzMessageService);
    private readonly fb = inject(NonNullableFormBuilder);
    private readonly cdr = inject(ChangeDetectorRef);

    constructor(
        @Inject(NZ_MODAL_DATA)
        public data: {
            nzTitle: string;
            articlesToRemove: ArticleSearchResponseDto[];
        },
    ) {
        this.validateForm = this.fb.group({
            article: [''],
            familiesIds: [[] as number[]],
            articleBatch: [''],
			packagingBatch: ['']
        });
    }

    async ngOnInit() {
        this.articlesToRemove = this.data.articlesToRemove ?? [];

		await this.articleFamilyService.setupWebSocket();
        this.articleFamilyService.articleFamilies$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (families) => {
                    this.articleFamilies = families;
                },
                error: () => {
                    this.message.error('Error cargando familias de artículo');
                }
            });

        this.isLoading = false;
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    handleCancel() {
        this.modalRef.close();
    }

	async search(){
		this.isSearching = true;
        await Promise.resolve();

		const articlesSearched = await this.articlesService.findAllWithArticleBatchesAndPackagings(this.validateForm.controls.article.value, this.validateForm.controls.familiesIds.value, this.validateForm.controls.articleBatch.value, this.validateForm.controls.packagingBatch.value);
        this.articles = articlesSearched.filter(article => !this.data.articlesToRemove.some(articleToRemove => articleToRemove.articleId === article.articleId && articleToRemove.articleBatchId === article.articleBatchId && articleToRemove.packagingId === article.packagingId));
		this.isSearching = false;
	}

	selectArticle(article: ArticleSearchResponseDto){
		this.isSaving = true;
        this.cdr.detectChanges(); // Fuerza la actualización visual antes del await
		this.emitService.next(article);
	}
}
